// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1A0u0","header":"Messages_header__2tY2b"};